
<template>

    <wizard-step-card
            header="Welches Problem möchten Sie melden?"
            :reason="_getCurrentReason"
            v-on:stepdone="stepDone"
            v-on:abbort="$emit('abbort')"
            btn-abbort-name="Beenden"
    >

        <div class="row">

            <div class="col-6 border-1">

                <info-header icon="fas fa-info-circle">
                    <template slot="titel">
                        Status des Auftrags
                    </template>

                    <template slot="leed">
                        Hier können Sie den aktuellen Status Ihres Auftrags sehen.
                    </template>
                </info-header>

                <div class="text-center center">
                    <b> Status:</b> &nbsp; {{ shippingStatus }}
                </div>

                <hr>

            </div>

            <div class="col-6 border-1">

                <info-header icon="fas fa-truck">
                    <template slot="titel">
                        Sendungsverfolgung
                    </template>

                    <template slot="leed">
                        Nutzen Sie die Sendungsverfolgung um Ihre Sendung zu finden!
                    </template>
                </info-header>

                <div class="text-center center">
                    <button @click="shippingTracking" class="btn btn-xl btn-info">Sendungsverfolgung öffnen</button>
                </div>

                <hr>

            </div>

            <div class="col-12 text-center" style="font-size: .8em; margin-top: 40px;">
                Wenn Sie das Problem mit hilfe der Sendungsverfolgung lösen konnten, können Sie den Assisten an dieser
                Stelle beenden.<br>
                <b>Benötigen Sie weitere Hilfe - Klicken Sie bitte auf weiter!</b>
            </div>

        </div>


        <div style="display: none">
            <iframe ref="shipping" frameborder="0" width="700" height="500" :src="shippingUrl"></iframe>
        </div>

    </wizard-step-card>

</template>

<script>

    import InfoHeader from '../../elements/InfoHeader'
    import WizardStepCard from '../../elements/WizardStepCard'

    export default {
        name: "shipping-tracker",
        components: {
            InfoHeader,
            WizardStepCard
        },

        data: () => ({
            showShippingStatus: false,
            shippingUrl: ''
        }),
        
        computed: {
            _getCurrentReason () {

                let reasonCode = this.$store.getters.getReason

                return this.$store.getters.getReasons[ reasonCode ] || 'Fehler - nicht gefunden!'
            },
            
            _getCurrentOrder () {

                let currentOrderId = this.$store.getters.getCurrentOrderId

                return this.$store.getters.getOrders.find(x => x.id === currentOrderId)
            },

            shippingStatus () {

                let status = this._getCurrentOrder.statusId

                switch ( true ){

                    case (status >= 7):
                        return 'Ihr Auftrag wurde versendet am ' + this._getCurrentOrder.dates.find(x => x.typeId === 5).date.substr(0,10).split('-').reverse().join('.')

                    case (status < 7):
                        return 'Ihr Auftrag wurde noch nicht versendet!'

                    default:
                        return 'Systemfehler!'
                }
            }
        },

        methods: {
            shippingTracking () {

                let trackingNumers = this._getCurrentOrder.packagenumber.join(',')

                this.shippingUrl = 'https://tracking.dpd.de/status/de_DE/parcel/' + trackingNumers
                this.showShippingStatus = true

                this.$swal({
                    content: this.$refs.shipping,
                    className: "shippingModal"
                })
                    .then(() => {
                        this.shippingUrl = ''
                        this.showShippingStatus = false
                    })

            },

            stepDone () {

                this.$emit('stepdone')
            }
        }
    }
</script>

<style scoped>
    .shippingModal { width: 750px }

    .center {
        min-height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>